import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_REVENUE_DYNAMIC_CPM = defineFcm('revenue_dynamic_cpm')
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				multiplier_percent: { type: 'number' },
				impressions_served_threshold: { type: 'number' },
				sign_conversion_percent_threshold: { type: 'number' },
			},
		}),
	)
	.withDefault(undefined)
	.toConfig({
		owner: 'squad-site-platform-payments',
		scope: 'promotion-service',
		context: 'promotion-service',
		description: 'Used as an experiment to give a better CPM ($ per impression) for better performing petitions',
		import: false,
		template: {
			multiplier_percent: 50,
			impressions_served_threshold: 1000,
			sign_conversion_percent_threshold: 5,
		},
	});
